import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { preloadEmojiTitle } from '@confluence/emoji-title/entry-points/preloadEmojiTitle.ts';
import { preloadEditorPageCoverPicture } from '@confluence/page-cover-picture/entry-points/preloadEditorPageCoverPicture.ts';
import type { EmojiTitleQuery$data } from '@confluence/emoji-title/entry-points/EmojiTitleQuery.ts';
import type { CoverPictureQuery$data } from '@confluence/page-cover-picture/entry-points/CoverPictureQuery.graphql.ts';

import SmartCreatePageEditorDataWrapperComponentQuery from './__generated__/SmartCreatePageEditorDataWrapperComponentQuery.graphql.ts';
import type {
	SmartCreatePageEditorDataWrapperComponentQuery$data,
	SmartCreatePageEditorDataWrapperComponentQuery$variables,
} from './__generated__/SmartCreatePageEditorDataWrapperComponentQuery.graphql.ts';

const preloadEditorData = async (contentId: string) => {
	return query<
		SmartCreatePageEditorDataWrapperComponentQuery$data,
		SmartCreatePageEditorDataWrapperComponentQuery$variables
	>({
		query: SmartCreatePageEditorDataWrapperComponentQuery,
		variables: {
			contentId,
		},
	});
};

export const preloadSmartCreateEditorData = async (
	contentId: string,
): Promise<
	| void
	| Error[]
	| (
			| {
					data: SmartCreatePageEditorDataWrapperComponentQuery$data | null;
					errors?: ReadonlyArray<GraphQLErrorInterop>;
					hasErrors: boolean;
			  }
			| {
					data: EmojiTitleQuery$data | null;
					errors?: ReadonlyArray<GraphQLErrorInterop>;
					hasErrors: boolean;
			  }
			| {
					data: CoverPictureQuery$data | null;
					errors?: ReadonlyArray<GraphQLErrorInterop>;
					hasErrors: boolean;
			  }
	  )[]
> => {
	return waitForAllReturnWhenError([
		preloadEditorData(contentId),
		preloadEmojiTitle(contentId, '', false),
		preloadEditorPageCoverPicture(contentId, '', false),
	]);
};
